import * as userSettings from './userSettings';
export * from './autosCoordinates';
export * from './userSettings';

const selectors = {
  ...userSettings
};

export default selectors;
